import apiClient from '@/services/axios'

export const getShippingMethodMaster = ({ business_id }) => {
  return apiClient({
    method: 'get',
    url: '/shippingv2/api/v1/shipping-methods',
    params: {
      business_id: business_id,
    },
  })
}

export const getShippingCourier = () => {
  return apiClient({
    method: 'get',
    url: '/shippingv2/api/v1/courier/list',
  })
}

export const getShippingService = ({ courier_id }) => {
  return apiClient({
    method: 'get',
    url: '/shippingv2/api/v1/shipping-methods-courier',
    params: {
      courier_id,
    },
  })
}

export const getShippingUnit = ({ product_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/shippingv2/api/v1/productShippingUnit/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
    params: { business_id },
  })
}

export const getShippingOrder = ({ signal, params }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/shippingv2/api/v1/shipping-orders',
    params,
  })
}

export const getMultiShippingDetail = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: 'shippingv2/api/v1/multi-shipping-details',
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getShippingOrderFromDashboard = ({ signal, order_id }) => {
  return apiClient({
    signal,
    method: 'get',
    url: `bi/dashboard2/internal/order/detail/${order_id}`,
  })
}

export const getShipmentLog = (params, url = '') => {
  return apiClient({
    method: 'get',
    url: `delivery/histories${url}`,
    params,
  })
}

export const shippingDelivered = ({ state, data }) => {
  return apiClient({
    method: 'post',
    url: `/shipping/cmd/${state}`,
    data,
  })
}

export const saveProductShipping = (data) => {
  return apiClient({
    method: 'put',
    url: `/shipping/cmd/product-shipping-unit/${data.product_id}`,
    data,
    params: {
      business_id: data.business_id,
    },
  })
}

export const getShippingDetailWithAttribute = ({ signal, order_id, business_id }) => {
  return apiClient({
    signal,
    method: 'get',
    url: `/shippingv2/internal/shipping-details/${order_id}`,
    headers: {
      'businessId': business_id,
    },
  })
}

export const getShippingDataLogapi = (params) => {
  return apiClient({
    method: 'get',
    url: '/logapi/carts/rate/2',
    params,
  })
}